// extracted by mini-css-extract-plugin
export var adjacentSlide = "_o8-9";
export var arrowButtonContainer = "_o8-5";
export var arrowButtonIcon = "_o8-6";
export var carouselArrowButton = "_o8-2";
export var carouselElementContainer = "_o8-1";
export var currentSlide = "_o8-8";
export var left = "_o8-3";
export var otherSlide = "_o8-a";
export var productCarouselContainer = "_o8-0";
export var right = "_o8-4";
export var sliderOverflow = "_o8-7";